import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

import { useViewOnly } from '@/contexts/InteractionParadigm.context';
import { COLORS } from '@/styles/tokens/colors';

export function HouseholdEstateValueMetricsCard({
  children,
}: PropsWithChildren) {
  const isViewOnly = useViewOnly();

  return (
    <Stack
      sx={{
        px: 3,
        py: 1.5,
        ...(isViewOnly
          ? {
              border: `1px solid ${COLORS.GRAY[200]}`,
              borderRadius: '6px',
            }
          : {
              borderBottom: `1px solid ${COLORS.GRAY[200]}`,
            }),
      }}
    >
      <Stack height="100%">{children}</Stack>
    </Stack>
  );
}
